module.exports = __webpack_public_path__ + "static/image/social-unrelated.svg?4157239b71a21c3771fb8d0bf2614d77";